"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceTransactionLabels = exports.DeviceTransactionStatus = void 0;
var DeviceTransactionStatus;
(function (DeviceTransactionStatus) {
    /** [UI/system] initial state */
    DeviceTransactionStatus["USER_REQUESTED"] = "USER_REQUESTED";
    /** [SQM] downlink removed */
    DeviceTransactionStatus["REJECTED_DUPLICATE_DOWNLINK"] = "REJECTED_DUPLICATE_DOWNLINK";
    /** [SQM] downlink approved */
    DeviceTransactionStatus["SYSTEM_VERIFIED"] = "SYSTEM_VERIFIED";
    /** [AWS/ChirpStack/TTNE] NAS has received the downlink */
    DeviceTransactionStatus["SENT_TO_NAS"] = "SENT_TO_NAS";
    /** [TTNE] NAS has received the downlink */
    DeviceTransactionStatus["QUEUED"] = "QUEUED";
    /** [ChirpStack/TTNE] Gateway transmitted the downlink */
    DeviceTransactionStatus["SENT"] = "SENT";
    /** [ChirpStack?/TTNE] Gateway didn't transmit the downlink */
    DeviceTransactionStatus["FAILED"] = "FAILED";
    /** @deprecated [?] ??? */
    DeviceTransactionStatus["ACK"] = "ACK";
    /** @deprecated [?] ??? */
    DeviceTransactionStatus["DEVICE_ACK"] = "DEVICE_ACK";
    /** [AWS/ChirpStack/TTNE] Device sent an uplink correlated to the downlink */
    DeviceTransactionStatus["DEVICE_RESPONSE"] = "DEVICE_RESPONSE";
    /** [ChirpStack?/TTNE] Device joined the NAS */
    DeviceTransactionStatus["JOIN_ACCEPT"] = "JOIN_ACCEPT";
    /** [?] ??? */
    DeviceTransactionStatus["DOWNLINK_CONFIG_ERROR"] = "DOWNLINK_CONFIG_ERROR";
})(DeviceTransactionStatus || (exports.DeviceTransactionStatus = DeviceTransactionStatus = {}));
exports.DeviceTransactionLabels = {
    REJECTED_DUPLICATE_DOWNLINK: 'Rejected (duplicate downlink)',
    USER_REQUESTED: 'Requested',
    SYSTEM_VERIFIED: 'Verified',
    SENT_TO_NAS: 'Sent to LNS',
    QUEUED: 'Queued',
    SENT: 'Sent to device',
    FAILED: 'Failed',
    ACK: 'Acknowledged',
    DEVICE_ACK: 'Acknowledged by device',
    DEVICE_RESPONSE: 'Device responded',
    JOIN_ACCEPT: 'Join accepted',
    DOWNLINK_CONFIG_ERROR: 'Downlink config error',
};
